import { NgModule, ModuleWithProviders, Type } from '@angular/core';

import { AnalyticsProvider } from './models';
import { AnalyticsService } from './services/analytics.service';

@NgModule({})
export class AnalyticsModule {
	public static forRoot(analyticsProvider: Type<AnalyticsProvider>): ModuleWithProviders<AnalyticsModule> {
		return {
			ngModule: AnalyticsModule,
			providers: [
				AnalyticsService,
				analyticsProvider,
				{
					provide: AnalyticsProvider,
					useExisting: analyticsProvider
				}
			]
		};
	}
}
